export default __webpack_public_path__ + "static/media/proj9.2a100b31.png";